module.exports = __webpack_public_path__ + "img/tv.0c2b3d75.svg";